export const isTokenValid = token => {
  return token != null;
};